export default __webpack_public_path__ + "locales/vi/PeopleTranslations.json?hash=23626f871230eeb9f01941b6bda4a145";